import React from 'react';
import { connect } from 'react-redux';
import Nav from './nav/index';
import logo from './../../../mg_dealer3.svg';

const Header = () => {
  const style = {
    display: 'flex',
    flex: '1 0 auto'
  }
  return (
    <div style={style} className='headerContainer' id='headerContainer'>
      <div style={{display: 'flex', flex: '0 0 50%'}}>
        <div style={{padding: '10px', display: 'flex', alignItems: 'center'}}>
          <img src={logo} alt='1' style={{height: '50px', marginLeft: '10px'}}></img>
        </div>
        <Nav />
      </div>
    </div>
  );
}

export default connect()(Header);



// WEBPACK FOOTER //
// ./src/components/layout/header/index.js